import React from "react";
import InputMask from "react-input-mask";

import { TooltipLabel } from "../components/tooltip";

//--- CUSTOM INPUT
// Label: Text
// Value: value input
// onChange: onInputChange
// valid: success / error / none

export const CustomInput = ({ label, name, value, onChange, valid }) => {
	return (
		<div className="custom-input">
			<div className={`wrap-input ${valid == "success" ? "success" : valid == "error" ? "error" : ""}`}>
				<div className="wrap-text">
					<p style={{ textAlign: "left" }}>{label}</p>
					<input type="text" value={value} onChange={onChange} name={name} />
				</div>
			</div>
		</div>
	);
};

export const CustomInputIcon = ({ icLeft, label, value, onChange, valid, icRight }) => {
	let svgLeft = icLeft;
	let svgRight = icRight;

	return (
		<div className="custom-input">
			<div className={`wrap-input ${valid == "success" ? "success" : valid == "error" ? "error" : ""}`}>
				<div className="wrap-svg">{svgLeft}</div>
				<div className="wrap-text">
					<p>{label}</p>
					<input type="text" value={value} />
				</div>
				{svgRight ? <div className="wrap-svg">{svgRight}</div> : null}
			</div>
		</div>
	);
};

export const CustomInputLabelOutside = ({
	icLeft,
	label,
	value,
	onChange,
	valid,
	icRight,
	status,
	type,
	name,
	placeholder,
	onKeyPress,
	disabled,
	inputMask,
}) => {
	let svgRight = icRight ? icRight : null;

	return (
		<div className="custom-input">
			<div className="wrap-info">
				<div className="title-status">
					<p>{label}</p>
					{/* {success && <div className="wrap-svg">{success}</div>} */}
				</div>
				<div className={`desc ${valid == "success" ? "text-success" : valid == "error" ? "text-danger" : ""}`}>
					{status}
				</div>
			</div>
			<div className={`wrap-input ${disabled ? "disabled" : ""}`}>
				<div className="wrap-text">
					{inputMask ? (
						!disabled ? (
							<InputMask name={name} mask="99-99-9999" defaultValue={value} onChange={onChange} />
						) : (
							<span>{value}</span>
						)
					) : (
						<input
							disabled={disabled}
							type={type}
							value={value}
							name={name}
							placeholder={placeholder ? placeholder : ""}
							onChange={onChange}
							onKeyPress={onKeyPress ? onKeyPress : null}
						/>
					)}
				</div>

				{svgRight}
			</div>
		</div>
	);
};

export const CustomSelect = ({ id, onChange, checked, name, label }) => {
	return (
		<div className="custom-checkbox-selected">
			<input type="checkbox" id={id} name={name} checked={checked} onChange={onChange} />
			<label htmlFor={id}>{label}</label>
		</div>
	);
};

export const CustomOnlyInput = ({ name, placeholder, onChange }) => {
	return (
		<div className="custom-input">
			<div className="wrap-input">
				<input type="text" name={name} placeholder={placeholder ? placeholder : ""} onChange={onChange} />
			</div>
		</div>
	);
};

export const CustomInputSimple = ({ label, name, placeholder, value, onChange }) => {
	return (
		<div className="custom-input">
			<div className="wrap-info">
				<div className="title-status">
					<p>{label}</p>
				</div>
			</div>
			<div className="wrap-input">
				<input type="text" value={value} placeholder={placeholder} name={name} onChange={onChange} />
			</div>
		</div>
	);
};

export const CustomTextarea = ({ placeholder, name, onChange, value }) => {
	return (
		<div className="custom-textarea">
			<textarea placeholder={placeholder ? placeholder : ""} name={name} onChange={onChange} value={value}></textarea>
		</div>
	);
};

export const CustomSelectTooltip = ({ id, onChange, checked, name, label, desc }) => {
	return (
		<div className="custom-checkbox-selected">
			<input type="checkbox" id={id} name={name} checked={checked} onChange={onChange} />
			<TooltipLabel id={id} title={label} desc={desc} />
		</div>
	);
};
